// extracted by mini-css-extract-plugin
module.exports = {"AppBody":"App_AppBody__cccV9"};